export const ORGANISATION_USER_ROLES = ['account_manager', 'pharmacist'] as const;
export type OrganisationUserRole = (typeof ORGANISATION_USER_ROLES)[number];

export const ROLE_LABELS: Record<OrganisationUserRole, string> = {
  account_manager: 'Admin',
  pharmacist: 'Pharmacist',
};

export type OrganisationUserInviteStatus = 'pending' | 'expired';

export interface OrganisationUserPharmacy {
  id: string;
  name: string;
}

export interface OrganisationUserInvite {
  status: OrganisationUserInviteStatus;
  invitedAt: string;
  expiresAt: string;
}

export interface OrganisationUser {
  userId: string;
  forename: string | null;
  surname: string | null;
  email: string;
  roles: OrganisationUserRole[];
  pharmacies: OrganisationUserPharmacy[];
  lastLoginAt: string | null;
  invite: OrganisationUserInvite | null;
  /** IPv4 addresses or CIDR ranges the user may sign in from; empty means unrestricted. */
  ipAllowList: string[];
}

/** The list endpoint predates the allow list, so an older API may omit the field. */
export type ListedOrganisationUser = Omit<OrganisationUser, 'ipAllowList'> &
  Partial<Pick<OrganisationUser, 'ipAllowList'>>;

export interface OrganisationUsersPagination {
  total: number;
  currentPage: number;
}

export interface ListOrganisationUsersResponse {
  users: ListedOrganisationUser[];
  pagination: OrganisationUsersPagination;
}

export interface OrganisationUsersList {
  users: OrganisationUser[];
  pagination: OrganisationUsersPagination;
}

export interface ListOrganisationPharmaciesResponse {
  pharmacies: OrganisationUserPharmacy[];
}

export interface InviteOrganisationUserRequest {
  email: string;
  roles: OrganisationUserRole[];
  /** Required when roles include pharmacist. */
  pharmacyIds?: string[];
  /** IPv4 addresses or CIDR ranges; omitted leaves sign-in unrestricted. */
  ipAllowList?: string[];
}

/** Replaces the user's roles, branches and allow list within one organisation. */
export interface SetOrganisationUserAccessRequest {
  roles: OrganisationUserRole[];
  /** Required when roles include pharmacist. */
  pharmacyIds?: string[];
  /** IPv4 addresses or CIDR ranges; an empty list removes the restriction. */
  ipAllowList: string[];
}

export interface InviteOrganisationUserResponse {
  userId: string;
  /** False when the user already had an account and was added to the organisation directly. */
  inviteSent: boolean;
}

export interface MyIpResponse {
  /** Public IPv4 address the API sees for the caller. */
  ip: string;
}
